'use client'

import React, { createContext, useContext, useMemo, useState } from 'react'

type LessonReviewProgressContextValue = {
  hasProgress: boolean
  setHasProgress: (hasProgress: boolean) => void
}

// 레이아웃(상단 뒤로가기)과 페이지(퀴즈 뷰)가 트리를 공유하지 않아 컨텍스트로 진행 여부를 전달한다.
// 기본값은 no-op — 프로바이더 밖(단위 테스트 등)에서도 뷰가 동작하도록.
const LessonReviewProgressContext = createContext<LessonReviewProgressContextValue>({
  hasProgress: false,
  setHasProgress: () => {},
})

export const LessonReviewProgressProvider = ({ children }: { children: React.ReactNode }) => {
  const [hasProgress, setHasProgress] = useState(false)
  const value = useMemo(() => ({ hasProgress, setHasProgress }), [hasProgress])

  return <LessonReviewProgressContext.Provider value={value}>{children}</LessonReviewProgressContext.Provider>
}

export const useLessonReviewProgress = () => useContext(LessonReviewProgressContext)
